import {combineReducers} from 'redux';

import bulkCreate from './plan-subscription-bulk-create/reducer';
import index from './plan-subscriptions-index/reducer';

export default combineReducers({index, bulkCreate});
